import ServiceBus from 'servicestack/service-bus'

class DashboardSourceBreakdownController  {
    constructor(createAutoQuery, $session) {
        this.$session = $session;
    }

    load() {
        let $ctrl = this;
        var bus = new ServiceBus();
        var request = {
            reportName: "DashboardSalesByRepGroupByOrderSource",
            dateRange: "YTD",
            status: "Open,Review,Completed,On Hold"
        }
        bus.send('RunReport.json', request).then(function (response) {
            $ctrl.query = response.data; 
        });
    }
}

class DashboardSourceBreakdown{
    constructor(){
        this.bindings= {
            date: '@',
        };
        this.controller = DashboardSourceBreakdownController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'dashboard-source-breakdown.html'
    }
}

angular.module('emun.shopping.admin').component('dashboardSourceBreakdown', new DashboardSourceBreakdown());

export default DashboardSourceBreakdown